export const pt = {
    common: {
        PIN_CODE_LABEL: 'Código PIN',
        USER_NAME_LABEL: 'Nome completo',
        comment: 'Comentário',
        year: 'Ano',
        configuration: 'Configuração',
        cancel: 'Cancelar',
        search: 'Pesquisar',
        remove: 'Remover',
        confirmationDialogTitle: 'Você tem certeza de remover este item?',
        selectDate: 'Selecionar data',
        select: 'Selecionar',
        notFound: 'Não encontrado',
        equipmentPickerPlaceholder: 'Objeto de equipamento...',
        searchPlaceholder: 'Pesquisar...',
        equipmentTypePickerPlaceholder: 'Tipo de equipamento...',
        equipmentTypePickerTitle: 'Selecionar tipo de equipamento',
        emptyTableMessage: 'Sem dados',
        flowPikcerTitle: 'Selecionar fluxo',
        selectIcon: 'Selecionar ícone',
        locationPickerTitle: 'Selecionar localização',
        locationPlaceholder: 'Localização...',
        noSublocations: 'Sem sublocalizações',
        locationsTitle: 'Localizações',
        edit: 'Editar',
        save: 'Salvar',
        added: 'Adicionado',
        updated: 'Atualizado',
        add: 'Adicionar',
        removed: 'Removido',
        reload: 'Recarregar',
        confirm: 'Confirmar',
        rollBack: 'Reverter',
        images: 'Imagens',
        documents: 'Documentos',
        download: 'Baixar',
        saved: 'Salvo',
        date: 'Data',
        hour: 'Hora',
        preview: 'Pré-visualização',
        data: 'Dados',
        attributes: 'Atributos',
        checkList: 'Lista de verificação',
        name: 'Nome',
        type: 'Tipo',
        status: 'Status',
        designation: 'Designação',
        symbol: 'Símbolo',
        serialNumber: 'Número de série',
        registryNumber: 'Número de registro',
        machineNumber: 'Número de máquina',
        udtNumber: 'Número UDT',
        manufacturedYear: 'Ano de fabricação',
        manufacturer: 'Fabricante',
        supplier: 'Fornecedor',
        mainSupplier: 'Fornecedor principal',
        attribute: 'Atributo',
        nameRequired: 'Nome é obrigatório',
        yearGreaterThan: 'O ano deve ser maior que',
        location: 'Localização',
        fieldRequired: 'Este campo é obrigatório',
        description: 'Descrição',
        minimumQuantity: 'Quantidade mínima',
        optimalQuantity: 'Quantidade ótima',
        priority: 'Prioridade',
        formatYYYY: 'Formato YYYY',
        storageQuantity: 'Quantidade em armazém',
        quantity: 'Quantidade',
        quantityGreaterThan: 'A quantidade deve ser maior que',
        machine: 'Máquina',
        tool: 'Ferramenta',
        order: 'Pedido',
        required: 'Obrigatório',
        dateFormat: 'Formato de data',
        selectDictionary: 'Selecionar dicionário',
        selectDictionaryValue: 'Selecione o valor do dicionário',
        return: 'Retornar',
        parameters: 'Parâmetros',
        editCategory: 'Editar categoria',
        addCategory: 'Adicionar nova categoria',
        changeColor: 'Mudar cor',
        noColor: 'Sem cor',
        shift: 'Turno',
        start: 'Início',
        end: 'Fim',
        shiftSchema: 'Esquema de turnos',
        shifts: 'Turnos',
        dictionary: 'Dicionário',
        subEntries: 'Subentradas',
        key: 'Chave',
        value: 'Valor',
        moveUp: 'Mover para cima',
        moveDown: 'Mover para baixo',
        addLocation: 'Adicionar nova localização',
        editLocation: 'Editar localização',
        companiesDatabase: 'Banco de dados de empresas',
        flows: 'Fluxos',
        read: 'Ler',
        write: 'Escrever',
        noImage: 'Sem imagem',
        email: 'E-mail',
        function: 'Função',
        active: 'Ativo',
        notActive: 'Não ativado',
        disabled: 'Desativado',
        entryNumber: 'Número de entrada',
        issuedDate: 'Data de emissão',
        expiresDate: 'Data de expiração',
        move: 'Mover',
        separateForm: 'Separar de',
        separate: 'Separar',
        warehouse: 'Armazém',
        actions: 'Ações',
        putInCurrentLocation: 'Colocar na localização atual',
        selectLocationFormRightMenu: 'Selecionar localização do menu à direita',
        showUnassignedItems: 'Mostrar itens não atribuídos',
        separated: 'Separado',
        moved: 'Movido',
        categories: 'Categorias',
        welcome: 'Bem-vindo',
        loginToSignaloCMMS: 'Entre no Signalo CMMS',
        login: 'Entrar',
        loginByEmailAndPassword: 'Entrar por e-mail e senha',
        loginByCode: 'Entrar pelo código',
        accessCode: 'Código de acesso',
        enterEmail: 'Insira o e-mail',
        enterPassword: 'Insira a senha',
        enterCode: 'Insira o código',
        userNotFound: 'Usuário não encontrado',
        userNotActivated: 'Usuário não ativado',
        userDisabled: 'Usuário desativado',
        wrongPassword: 'Senha incorreta',
        locations: 'Localizações',
        pageNotFound: 'Página não encontrada',
        group: 'Grupo',
        yes: 'Sim',
        no: 'Não',
        hourlyCost: 'Custo por hora',
        price: 'Preço',
        newEntry: 'Nova entrada',
        predictedFinishTime: 'Tempo previsto de conclusão',
        ok: 'Ok',
        archive: 'Arquivo',
        costs: 'Custos',
        companyManagement: 'Gerenciamento de empresas',
        companyData: 'Dados da empresa',
        supportedLanguages: 'Idiomas suportados',
        en: 'Inglês',
        pl: 'Polonês',
        es: 'Espanhol',
        de: 'Alemão',
        it: 'Italiano',
        fr: 'Francês',
        ru: 'Russo',
        uk: 'Ucraniano',
        pt: 'Português',
        tr: 'Turco',
        nl: 'Holandês',
        sr: 'Sérvio',
        defaultLanguage: 'Idioma padrão',
        companyLogo: 'Logotipo da empresa',
        notificationsManagement: 'Gerenciamento de notificações',
        category: 'Categoria',
        today: 'Hoje',
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        close: 'Fechar',
        show: 'Mostrar',
        rollBackFormalConfirmation: 'Confirmação formal de reversão',
        signUp: 'Cadastre-se',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Rótulo do nome completo',
        userNameSurname: 'Nome completo',
        userSurnameName: 'Sobrenome e nome',
        phone: 'Número de telefone',
        password: 'Senha',
        password_confirmation: 'Confirme a senha',
        unassignedItems: 'Itens não atribuídos',
        currency: 'Moeda',
        general: 'Geral',
        timezone: 'Fuso horário',
        users: 'Usuários',
        groups: 'Grupos',
        productionLine: 'Linha de produção',
        part: 'Peça',
        fittingParts: 'Peças ajustáveis',
        workSchema: 'Esquema de trabalho',
        workSchemas: 'Esquemas de trabalho',
        holiday: 'Feriado',
        changePassword: 'Mudar senha',
        showRest: 'Mostrar o resto',
        pageNotPermitted: 'Página não permitida',
        waitingForActivation: 'Aguardando ativação',
        editGroup: 'Editar grupo',
        addGroup: 'Adicionar grupo',
        reportProblem: 'Relatar problema',
        describeOccuredIssue: 'Descreva o problema ocorrido',
        markAllAsRead: 'Marcar tudo como lido',
        unitType: 'Tipo de unidade',
        unit: 'Unidade',
        unitPrice: 'Preço por unidade',
        notConfigured: 'Não configurado',
        rowsPerPage: 'Linhas por página',
        rowsOfPage: 'de',
        true: 'Verdadeiro',
        false: 'Falso',
        export: 'Exportar',
        chooseFileFormat: 'Escolha o formato do arquivo',
        exported: 'Exportado',
        terminals: 'Terminais',
        terminal: 'Terminal',
        selectEquipment: 'Selecionar equipamento',
        futureIssues: 'Problemas futuros',
        scheduledOn: 'Agendado em',
        planned: 'Planejado',
        notPlanned: 'Não planejado',
        showOpenIssues: 'Mostrar problemas abertos',
        pin: 'PIN',
        assignedEquipment: 'Equipamento atribuído',
        terminalEquipment: 'Equipamento do terminal',
        detach: 'Desanexar',
        attach: 'Anexar',
        dashboardConfig: 'Configuração do painel',
        addColumn: 'Adicionar coluna',
        addRow: 'Adicionar linha',
        removeRow: 'Remover linha',
        registerTerminal: 'Registrar terminal',
        issueGeneratesCost: 'Tempo de inatividade gera custo',
        selectColor: 'Selecionar cor',
        belowMinimum: 'Abaixo do mínimo',
        belowOptimum: 'Abaixo do ótimo',
        synchronization: 'Sincronização',
        synchronizationExport: 'Exportação de peças em estoque',
        synchronizationImport: 'Importação de peças em estoque',
        mapping: 'Mapeamento',
        returnTo: 'Voltar para',
        jobStatusses: 'Processos',
        hidden: 'Oculto',
        editEvent: 'Editar evento',
        threeDays: '3 dias',
        addEvent: 'Adicionar evento',
        plannedIssues: 'Problemas planejados',
        currentService: 'Serviço atual',
        searchLocation: 'Procurar localização',
        all: 'Todos',
        unfinished: 'Incompleto',
        numberOfIssues: 'Quantidade de problemas',
        unknown: 'Desconhecido',
        partEntry: 'Peça (entrada)',
        foundItems: 'Itens encontrados',
        output: 'Saída',
        copied: 'Copiado',
        link: 'Link',
        authorizationRequired: 'Autorização necessária',
        authorizationRequiredDescriptionUser:
            'Infelizmente, você não tem autorização suficiente {value}. Peça para uma pessoa autorizada aprovar a ação.',
        authorizationRequiredDescriptionTerminal:
            'Use seu código de acesso para autorizar a ação.',
        showAll: 'Mostrar tudo',
        showClassicView: 'Visão clássica',
        noIssuesInCategory: 'Não há problemas nesta categoria.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Número de problemas nesta categoria e subcategorias.',
        numberOfIssuesInThisCategory: 'Número de problemas nesta categoria.',
        minBarcodeLength: 'Comprimento mínimo de código de barras',
        currentPage: 'Página atual',
        allPages: 'Todas as páginas',
        selectFormat: 'Selecionar formato',
        provided_currency: 'Moeda fornecida',
        provided_quantity: 'Quantidade fornecida',
        provided_unit: 'Unidade fornecida',
        provided_unit_price: 'Preço por unidade fornecido',
        unit_price: 'Preço por unidade',
        quantity_available: 'Quantidade disponível',
        editBarcode: 'Editar código de barras',
        crews: 'Equipes',
        scheduleEventTypes: 'Tipos de eventos agendados',
        crew: 'Equipe',
        scheduleEvent: 'Evento agendado',
        available: 'Disponível',
        'App\\Models\\Crew': 'Equipe',
        'App\\Models\\User': 'Usuário',
        'App\\Models\\Equipment': 'Equipamento',
        'App\\Models\\Part': 'Papel',
        Crew: 'Equipe',
        User: 'Usuário',
        Equipment: 'Equipamento',
        Part: 'Papel',
        scheduleEvents: 'Eventos agendados',
        event: 'Evento',
        externalSystems: 'Sistemas externos',
        user: 'Usuário',
        availability: 'Disponibilidade',
        inheritColorFromParentIfCustomNotSet:
            'Herdar cor do pai se personalização não estiver definida',
        pickFromAllParts: 'Selecionar de todas as peças',
        takeTool: 'Pegar ferramenta',
        returnTool: 'Devolver ferramenta',
        personWhoTake: 'Pessoa que pega',
        personWhoReturn: 'Pessoa que devolve',
        takenAt: 'Pego em',
        takenBy: 'Pego por',
        toolIssuedBy: 'Ferramenta emitida por',
        commentTake: 'Comentário de pegar',
        commentReturn: 'Comentário de devolver',
        change: 'Mudar',
        onlyWithActiveRMIssues: 'Somente com solicitações de RM ativas',
        externalSystem: 'Sistema externo',
        rejectIssue: 'Rejeitar problema',
        withdrawIssueRejection: 'Retirar rejeição de problema',
        rejectionReason: 'Razão da rejeição',
        rejected: 'Rejeitado',
        showCrewMembers: 'Mostrar membros da equipe',
        crewMembers: 'Membros da equipe',
        helpGroup: 'Serviço',
        partsTakenByUser: 'Peças retiradas pelo usuário',
        pickParts: 'Emitir peças',
        selectPersonWhoTakes: 'Selecione a pessoa que retira',
        changePersonWhoTakes: 'Mudar pessoa que retira',
        quantityToPick: 'Quantidade para pegar',
        pickLocation: 'Localização de retirada',
        selectPartsToPick: 'Selecione as peças para pegar',
        partSelected: 'Peça selecionada',
        scanCodeOr: 'Escaneie o código ou',
        returnPart: 'Devolver parte',
        myTakenParts: 'Peças retiradas por mim',
        takenFromLocation: 'Retirado da localização',
        takenQuantity: 'Quantidade retirada',
        providedUnit: 'Unidade fornecida',
        providedQuantity: 'Quantidade fornecida',
        selectFromStorage: 'Selecionar do armazenamento',
        selectFromMyPickedParts: 'Selecionar de minhas peças retiradas',
        exportProcessInProgressMessage:
            'O processo de exportação de dados acabou de começar, quando estiver concluído, você verá uma notificação correspondente contendo um link para o arquivo.',
        yourDocumentIsReady: 'Seu documento está pronto',
        rotateScreen: 'Girar tela',
        addRule: 'Adicionar regra',
        editRule: 'Editar regra',
        summary: 'Resumo',
        onlyAvailableEmployees: 'Mostrar apenas empregados disponíveis',
        calculated_unit_price: 'Preço unitário convertido',
        calculated_quantity: 'Quantidade convertida',
        next: 'Seguinte',
        maintenanceMode: 'Modo de manutenção',
        applicationMayBeUnavailableForFewMinutes:
            'O pedido pode ficar indisponível durante alguns minutos',
        appWillRefreshIn: 'A aplicação será recarregada em',
        landscape: 'Paisagem',
        portrait: 'Retrato',
        orientation: 'Orientação',
        format: 'Formato',
        service: 'Criados',
        leader: 'Capatazes',
        defaultView: 'Vista por defeito',
        view: 'Vista',
        oneDay: '1 dia',
        object: 'Objecto',
        finished: 'Terminado',
        onlyNotFinished: 'Só não acabou',
        generate: 'Gerar',
        error: 'Erro',
        cell: 'Célula',
        resolutionSummary: 'Resumo final',
        rejected_at: 'Data de rejeição',
        rejected_by: 'Rejeitado por',
        finishedByUser: 'Completado por',
        formalConfirmByUser: 'Confirmação formal por',
        formalConfirmAt: 'Data de confirmação formal',
        valueDeleted: '[Valor excluído]',
        hasNotPlannedIssue: 'Não planejou problemas',
        showInStorage: 'Mostrar no armazenamento',
        changeCode: 'Mude o código',
        staffProfiles: 'Perfis de funcionários',
        profile: 'Perfil',
        user_bug: 'Błąd aplikacji',
        user_kaizen: 'Sugestia zmiany',
        changeSuggestions: 'Alterar sugestões',
        showOnlyCurrentlyAvailable: 'Mostrar apenas disponível no momento',
        resetPassword: 'Lembrar senha',
        forgotPassword: 'Esqueceu sua senha',
        resetPasswordMailSent:
            'Enviamos um link para definir uma nova senha para o endereço de e-mail fornecido',
        manyEventsThisTime: 'Muitos eventos neste momento',
        importScheduleCheckboxLabel:
            'Excluir eventos agendados no mês selecionado para funcionários listados no arquivo',
        inheritedEvent: 'Evento herdado',
        inheritedModifiedEvent: 'Evento herdado modificado',
        equipmentId: 'ID do equipamento',
        entryId: 'ID de entrada',
        partId: 'ID da peça',
        suggestionsEmail:
            'E-mail para o qual serão enviadas as sugestões de alteração',
        meters: 'Contadores',
        scanCardToAuth:
            'Toque o cartão no leitor ou digite seu código de acesso para confirmar sua identidade.',
        scanCard: 'Escaneie o cartão',
        cart: 'Caixa de troca',
        emptyCardMessage:
            'Comece a digitalizar produtos ou selecione-os na lista para adicioná-los à cesta.',
        terminalMode: 'tipo de terminal',
        askPermittedUserToConfirmPartsExchange:
            'Peça à pessoa autorizada para confirmar a liberação da peça digitalizando o cartão ou digitando o código.',
        partsIssued: 'Peças lançadas',
        areYouSureAboutCancel: 'Tem certeza de que deseja cancelar?',
        areYouSureAboutRemoveFromCart:
            'Tem certeza de que deseja remover este item do carrinho?',
        standard: 'Padrão',
        idNumber: 'Número de identificação',
        takeParts: 'Retirar peças',
        returnParts: 'Devolver peças',
        quantityToReturn: 'Quantidade para devolver',
        partsPendingApproval: 'Peças pendentes de aprovação',
        partsReturned: 'Peças devolvidas',
        partsAddedToPendingApproval: 'Peças adicionadas à aprovação pendente',
        approvePartsReturn: 'Aprovar devolução de peças',
        partReturnApproved: 'Devolução de peças aprovada',
        partUsage: 'Uso de peças',
        awaitsReturn: 'Aguarda devolução',
        entrySelection: 'Seleção de entrada',
        correctQuantity: 'Corrigir quantidade',
        quantityCorrection: 'Correção de quantidade',
        entrySelectionAsc: 'Seleção de entrada ascendente',
        entrySelectionDesc: 'Seleção de entrada descendente',
        metersSettings: 'Configurações de contadores',
        countableFields: 'Campos contáveis',
        equipmentTypes: 'Tipos de equipamento',
        fieldName: 'Nome do campo',
        countableField: 'Campo contável',
        partsStatusTaken: 'Retirado',
        rejectPartsReturn: 'Rejeitar devolução de peças',
        areYouSureAboutRejectPartsReturn:
            'Tem certeza de que deseja rejeitar a devolução de peças?',
        partReturnRejected: 'Devolução de peças rejeitada',
        counterFields: 'Campos de contadores',
        counterName: 'Nome do contador',
        counterFieldName: 'Nome do campo do contador',
        counterId: 'ID do contador',
        counterUUID: 'UUID do contador',
        counterPickerPlaceholder: 'Selecione o contador',
        pickFromPartsList: 'Escolha da lista de peças',
        changeLocation: 'Mudar localização',
        isPartStorageRoot: 'Raiz do armazenamento de peças',
        isStorageRoot: 'Raiz do armazenamento de peças',
        areYouSureAboutArchiveIssue:
            'Tem certeza de que deseja arquivar este problema?',
        ganttChart: 'Gráfico de Gantt',
        table: 'Tabela',
        fittingEquipment: 'Equipamento de montagem',
        notAssigned: 'Não atribuído',
        counters: 'Contadores',
        machineHourlyCostNotProvided:
            'O custo horário da máquina não foi fornecido',
        eventTypesMightBeDefinedHere:
            'Os tipos de eventos podem ser definidos aqui',
        toolsTakenByUser: 'Ferramentas retiradas pelo usuário',
        predictedReturnDate: 'Data de devolução prevista',
        estimatedTimeOfUsingToolInHours:
            'Tempo estimado de uso da ferramenta (em horas)',
        showOnlyAvailable: 'Mostrar apenas disponível',
        toolTakeLog: 'Registro de retirada de ferramentas',
        takeDate: 'Data de retirada',
        returnDate: 'Data de devolução',
        personWhoAcceptReturn: 'Pessoa que aceita a devolução',
        statisticStrategy: 'estratégia de acessibilidade',
        EquipmentPlannedStrategy: 'De acordo com o plano de trabalho',
        EquipmentConstantAvailabilityStrategy: 'Sempre disponível',
        actionAfterIssueFinish: 'Ação após o término do problema',
        enabled: 'Habilitado',
        categoryOfNewIssue: 'Categoria de novo problema',
        workNotStarted: 'Trabalho não iniciado',
        colorInherited: 'Cor herdada',
        abcClassification: 'Classificação ABC',
        xyzClassification: 'Classificação XYZ',
        classification: 'Classificação',
        filters: 'Filtros',
        wipeFilters: 'Limpar filtros',
        takePartsFromUser: 'Retirar peças do usuário',
        selectPersonWhoReturns: 'Selecione a pessoa que devolve as peças',
        changePersonWhoReturns: 'Alterar a pessoa que devolve as peças',
        returnLocation: 'Local de devolução',
        returnQuantity: 'Quantidade de devolução',
        globalSettings: 'Configurações globais',
        delimiter: 'Delimitador',
        fieldRules: 'Regras de campo',
        fieldValue: 'Valor do campo',
        user_email_regex: 'Regex de e-mail do usuário',
        barcodeLength: 'Comprimento do código de barras',
        partLine: 'Linha de peças',
        partFamily: 'Família de peças',
        partBatch: 'Lote de peças (batch)',
        testValueValid: 'valor de teste válido',
        testValueNotValid: 'Valor de teste inválido',
        canBePicked: 'Pode ser escolhido',
        issue_criticality: 'Problemas - criticidade',
        issue_help_webapp: 'Problemas - suporte necessário (aplicativo)',
        issue_help_terminal: 'Problemas - suporte necessário (Terminal)',
        issue_kind: 'Tipo de relatório',
        HIDE: 'Esconder',
        SHOW: 'Mostrar',
        REQUIRE: 'Exigir',
        propagateValues: 'Propagação de valor',
        archived: 'Arquivado',
        singleEvent: 'Entrada única',
        seriesOfEvents: 'Uma série de entradas',
        omitWeekends: 'Evite fins de semana',
        allEntriesSaved: 'Todas as entradas foram adicionadas',
        parentCategory: 'Categoria Parental',
        first_day_of_week: 'Primeiro dia da semana',
        assignEmployee: 'Atribuir um funcionário',
        addNewMachine: 'Adicionar uma nova máquina',
        addNewTool: 'Adicionar uma nova ferramenta',
        parentLocation: 'Localização pai',
        equipmentStates: 'Estados do equipamento',
        equipmentState: 'Condição do equipamento',
        fontColor: 'Cor da fonte',
        downtime: 'Tempo de inatividade',
        setState: 'Definir estado',
        from: 'de',
        to: 'para',
        inProgress: 'em andamento',
        noEntries: 'nenhuma entrada',
        products: 'produtos',
        product: 'produtos',
        setCurrentProduct: 'Defina o produto atualmente em produção',
        commentable: 'Possibilidade de comentar',
        allows_state_update:
            'Mudança de estado necessária durante o comentário',
        undescribed: 'Indescritível',
        state: 'Doença',
        productionMonitor: 'Monitor de produção',
        undescribedStates: 'Estados não descritos',
        toolsPicker: 'Ferramentas de levar / devolver',
        toolsGroups: 'Grupos de ferramentas',
        of: 'de',
        image: 'Foto',
        selectTools: 'Escolha ferramentas',
        takeTools: 'Baixar ferramentas',
        returnTools: 'Devolva as ferramentas',
        askPermittedUserToConfirmToolsExchange:
            'Solicite à pessoa autorizada que confirme a emissão/devolução das ferramentas digitalizando o cartão ou inserindo o código.',
        toolsPendingApproval: 'Ferramentas devolvidas aguardando aprovação',
        production_monitor_visible_columns:
            'Monitor de produção - colunas visíveis',
        details: 'Detalhes',
        otherData: 'Outros dados',
        showAllTools: 'Mostrar todas as ferramentas',
        allTools: 'Todas as ferramentas',
        approveToolReturn: 'Aceite a devolução da ferramenta',
        rejectToolReturn: 'Rejeitar a devolução da ferramenta',
        areYouSureAboutRejectToolReturn:
            'Tem certeza de que deseja rejeitar a devolução da ferramenta?',
        areYouSureAboutAcceptToolReturn:
            'Tem certeza de que deseja confirmar a devolução da ferramenta?',
        toolReturnApproved: 'Devolução de ferramenta aprovada',
        toolReturnRejected: 'Devolução de ferramenta rejeitada',
        toReturn: 'Para retornar',
        toolsCart: 'Caixa de troca - ferramentas',
        toolsIssued: 'Ferramentas baixadas',
        toolsAddedToPendingApproval:
            'As ferramentas foram adicionadas à lista de espera para aprovação de devolução',
        toolsReturned: 'Ferramentas devolvidas',
        mainShift: 'Turno principal',
        scanCode: 'Digitalize o código',
        codeRecognized: 'Código reconhecido',
        moveAllEntriesFromCurrentLocation:
            'Mover todas as entradas deste local',
        newAwaitingValue: 'Novo valor aguardando aprovação',
        newValuesArePendingConfirmation: 'As mudanças aguardam aprovação',
        changeRequests: 'Pedidos de mudança',
        currentValues: 'Valores atuais',
        requestedValues: 'Valores a alterar',
        removeRequestIsWaitingForApprove:
            'A exclusão está pendente de aprovação',
        imageRemoveRequestLabel: 'Excluindo uma foto',
        areYouSureAboutCancelChangeRequest:
            'Tem certeza de que deseja cancelar a solicitação de alteração?',
        document: 'Documento',
        rename: 'Renomear',
        openInEditor: 'Abrir no editor',
        unsavedChangesMayBeLost: 'As alterações não salvas podem ser perdidas',
        location_name_regex: 'Regra de nome de local',
        employeesWorkingCount:
            'Número de funcionários trabalhando nesta questão',
        always: 'Sempre',
        indexes: 'Índices',
        indexesEntriesTypes: 'Tipos de entrada',
        indexEntry: 'Entrada de índice',
        index: 'Índice',
        pickIndex: 'Selecione um índice',
        report: 'Relatório',
        reportGenerationInProgress: 'O relatório está gerando',
        production_monitor_equipment_state_change:
            'Alterando o status da máquina no monitor de produção',
        part_entries_auto_barcode_generation:
            'Geração automática de códigos de barras para entradas de peças',
        new_issue_equipment_kind: 'Tipo de equipamento na nova aplicação',
        manageVisibleColumns: 'Ajustar a visibilidade da coluna',
        columnName: 'Nome da coluna',
        visible: 'Visível',
        partStorageRootWarningMessage:
            'Este local será definido como o local principal do armazém de peças, o armazém e a janela de seleção do local do armazém só permitirão que você selecione entradas localizadas neste local',
        entriesLocation: 'localização das entradas',
        cloneIssue: 'Clone',
        machinesMap: 'Mapa da máquina',
        doYouWantToAddNewMarker: 'Gostaria de adicionar uma nova tag aqui?',
        areYouSureAboutRemoveMarker:
            'Tem certeza de que deseja remover esta tag?',
        plants: 'Plantas fabris',
        plant: 'Fábrica',
        buildings: 'Edifícios',
        building: 'Prédio',
        floors: 'Pisos',
        floor: 'Chão',
        map: 'Mapa',
        areYouSureAboutMoveMarker:
            'Tem certeza de que deseja mover este marcador?',
        marker: 'Marcador',
        addNewMarkerTooltipMessage:
            'Para adicionar um novo marcador, clique com o botão direito no mapa.',
        takenTools: 'Ferramentas liberadas',
        askPermittedUserToConfirmToolExchange:
            'Solicite à pessoa autorizada que confirme a emissão/devolução da ferramenta digitalizando o cartão ou inserindo o código.',
        warnDays: 'Alerta antes da expiração (dias)',
        licenseType: 'Tipo de licença',
        licenseGroup: 'Grupo de licença',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Exigir confirmação / rejeição após devolução de ferramentas baixadas',
        attachments: 'Anexos',
        attachment: 'Anexo',
        searchInCurrentLocation: 'Pesquise na sua localização atual',
        icon: 'Ícone',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'outro',
        tags: 'Cartões / Tags',
        tag: 'Cartão / Tag',
        userPinCode: 'PIN do usuário do cartão',
        pin_code_field_type: 'Tipo de código PIN',
        alphanumeric: 'Alfanumérico',
        numeric: 'Numérico',
        showCodeOwnerNameDuringParing:
            'Mostrar o nome do proprietário do código ao emparelhar com cartão/etiqueta',
        showUsernameInCart: 'Mostrar nome de usuário no carrinho',
        flag: 'Bandeira',
        flags: 'Bandeiras',
        manageFlags: 'Gerenciar sinalizadores',
        skills: 'Habilidades',
        skill: 'Habilidade',
        skillRank: 'Avaliação',
        selectToolsByType: 'Selecione ferramentas por tipo',
        openToolsPickerOnCartInit:
            'Abra automaticamente a janela de seleção de ferramentas quando for ao carrinho.',
        toolsTypes: 'Tipos de ferramentas',
        workOrderTemplates: 'Modelos de ordem de serviço',
        workOrderTemplate: 'Modelo de ordem de serviço',
        workOrders: 'Ordens de trabalho',
        workOrder: 'Ordem de serviço',
        employee: 'Funcionário',
        workOrderCreatedBy: 'Comissionado por',
        print: 'Imprimir',
        issueCreated: 'Um ticket foi criado',
        newIssue: 'Novo relatório',
        sampleButtonPlaceholder: 'Botão de amostra',
        preferences: 'Preferências',
        buttonsSize: 'Tamanho do botão',
        defaultValue: 'Valor padrão',
        warning: 'Aviso',
        allowedIssuesCategories: 'Categorias de problemas permitidos',
        hideAbilityToAssignEmployeesToIssue:
            'Ocultar a capacidade de atribuir funcionários a um problema',
        issuesWithRelatedCategories: 'Incluir subcategorias',
        issuesLimit: 'Limite de problemas',
        issuesLimits: 'Problemas - limites',
        closeLocker: 'Feche o armário',
        closeLockerMessage: 'Para continuar, feche o gabinete',
        closedTooFast: 'Você fechou muito rápido?',
        doYouWantToReopenLocker: 'Quer reabrir o armário?',
        reopen: 'Reabrir',
        quit: 'Terminar',
        hiddenFields: 'Campos ocultos',
        defaultValues: 'Valores padrão',
        paddingBottom: 'Espaço vazio na parte inferior',
        allVisibleFieldsRequired:
            'Exigir que todos os campos visíveis sejam preenchidos',
        emailConfirmation: 'Confirmação de endereço de e-mail',
        user_active_after_email_confirm:
            'Conta de usuário ativada automaticamente após confirmar seu endereço de e-mail',
        phone_change_requires_confirmation_code:
            'A alteração do número de telefone requer confirmação com um código',
        toolsLocation: 'Localização da ferramenta',
        manageFilters: 'Gerenciar filtros',
        erase: 'Apagar',
        can_pick_undescribed_equipment_state:
            'Possibilidade de escolher um estado indescritível',
        helpdesk: 'Central de Ajuda',
        measureTypes: 'Tipos de medições',
        measureType: 'Tipo de medição',
        measurable: 'Indicador mensurável',
        measurables: 'Indicadores mensuráveis',
        measurements: 'Medição',
        measurement: 'Medição',
        measuredAt: 'Data de medição',
        employeeNumber: 'Número de empregado',
        lastLocation: 'Última localização',
        readonly: 'Somente leitura',
        equipment: 'Equipamento',
        conditions: 'Condições',
        permission: 'Permissão',
        formula: 'Fórmula',
        notification: 'Notificação',
        transition: 'Transição',
        fillValuesToChangeState: 'Preencha os valores para alterar o status.',
        loginTo: 'Logar em',
        appName: 'Signalo CMMS',
        manageState: 'Gerenciar estado',
        webMessage: 'Mensagem da web',
        terminalId: 'ID do terminal',
        operatorId: 'ID do operador',
        newConversation: 'Novo tópico',
        application: 'Aplicativo',
        phones: 'Números de telefone',
        message: 'Mensagem',
        channels: 'Canais',
        url: 'URL',
        kind: 'Tipo',
        forkfleetConfigId: 'Configuração Forkfleet',
        create: 'Criar',
        terminate: 'Terminar',
        recreateIssue: 'Recrie o ticket',
        ordinal: 'Valor ordinal',
        parameterName: 'Nome do parâmetro',
        backgroundColor: 'Cor de fundo',
        columns: 'Numero de colunas',
        colspan: 'Largura (colunas)',
        fill: 'Completo',
        duplicate: 'Duplicado',
        loginAsThisUser: 'Faça login como este utilizador',
        partLot: 'Séries',
        minBrowserVersion: 'Versão mínima do browser necessária',
        currentVersion: 'Versão Atual',
        equipment_planned_completed_percent_target:
            'Meta percentual para a implementação de inspeções planeadas',
        autoTranslate: 'Tradução automática',
        auto_translation: 'Tradução automática',
        awaitingAutoTranslation: 'Aguardando tradução automática',
        signaturePinTagConfirmationText1: 'Assinar com @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'ou escaneie seu cartão.',
        signedWithPinCode: 'Assinado com @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Assinado com cartão/etiqueta',
        trusted_device_code_login_users_limit:
            'Login rápido - número de utilizadores apresentados',
        display_fields_issue_show: 'Mostrar campos - Criação de um relatório',
        docs_sidebar_hidden_by_default:
            'Documentos - ocultar barra lateral por default',
        issue: 'Relato',
        control: 'Controle',
        compatibility: 'Compatibilidade',
        replacement: 'Substituição',
        backCompatibility: 'Compatibilidade bidirecional',
    },
    placeholders: {
        part: 'Selecionar parte...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Número de telefone...',
        password: 'Senha...',
        password_confirmation: 'Confirme a senha...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Não é sua conta?',
    },
    signup: {
        registered: 'Sucesso!',
        emailConfirmed: 'O e-mail foi confirmado.',
        registered_info: 'Peça ao seu supervisor para ativar sua conta',
        confirmEmailAddress:
            'Sua conta foi criada, clique no link do e-mail para confirmar seu endereço.',
        tokenNotFoundError:
            'O e-mail já foi confirmado ou o link de confirmação é inválido.',
    },
    paramTypes: {
        text: 'Texto',
        note: 'Nota',
        integer: 'Inteiro',
        decimal: 'Decimal',
        date: 'Data',
        time: 'Hora',
        datetime: 'Data e hora',
        color: 'Cor',
        icon: 'Icone',
        boolean: 'Não / Sim',
        signature: 'Assinatura',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Nome',
        path: 'Caminho para arquivo',
        category: 'Categoria',
        equipment: 'Equipamento',
        criticality: 'Criticidade',
        status: 'Status',
        created: 'Criado',
        createdBy: 'Criado por',
        fp: 'FP',
        type: 'Tipo',
        designation: 'Designação',
        symbol: 'Símbolo',
        serialNumber: 'Número de série',
        registryNumber: 'Número de registro',
        udtNumber: 'Número UDT',
        manufacturedYear: 'Ano de fabricação',
        actions: 'Ações',
        title: 'Título',
        data: 'Data',
        archived: 'Arquivado',
        manufacturerSymbol: 'Símbolo do fabricante',
        min: 'Min',
        opt: 'Óptimo',
        quantity: 'Quantidade',
        priority: 'Prioridade',
        price: 'Preço',
        kind: 'Tipo',
        description: 'Descrição',
        default: 'Padrão',
        warning: 'Aviso',
        problem: 'Problema',
        fixing: 'Correção',
        changeOrder: 'Ordem de mudança',
        required: 'Necessário',
        icon: 'Icone',
        color: 'Cor',
        subCategories: 'Subcategorias',
        barCode: 'Código de barras',
        subLocations: 'Sublocalizações',
        categories: 'Categorias',
        image: 'Imagem',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Email',
        phone: 'Número de telefone',
        function: 'Função',
        department: 'Departamento',
        accountStatus: 'Status da conta',
        shift: 'Turno',
        licenseNumber: 'Número de licença',
        issuedDate: 'Data de emissão',
        expiresDate: 'Data de expiração',
        entries: 'Entradas',
        entryNumber: 'Número de entrada',
        buyPrice: 'Preço de compra',
        currentLocationQuantity: 'Quantidade na localização atual',
        group: 'Grupo',
        string: 'Texto',
        integer: 'Inteiro',
        toolsGroup: 'Grupo de ferramentas',
        manufacturer: 'Fabricante',
        shortName: 'Nome curto',
        locationName: 'Nome da localização',
        subLocationsQuantity: 'Quantidade de sublocalizações',
        isWorkingOnIssue: 'Trabalhando em problema',
        openIssues: 'Problemas abertos',
        notificationDate: 'Data de notificação',
        titleAndDescription: 'Título e descrição',
        read: 'Ler',
        created_at: 'Criado',
        received_at: 'Recebido',
        started_at: 'Começou',
        arrived_at: 'Chegou',
        finished_at: 'Concluído',
        country: 'País',
        city: 'Cidade',
        progress: 'Progresso',
    },
    searchConfig: {
        id: 'Id',
        name: 'Nome...',
        shortName: 'Nome curto...',
        country: 'País...',
        email: 'E-mail...',
        group: 'Grupo...',
        planned: 'Planejado',
        category: 'Categoria...',
        object: 'Objeto...',
        criticality: 'Criticidade',
        fp: 'FP',
        type: 'Tipo...',
        designation: 'Designação...',
        symbol: 'Símbolo...',
        serialNumber: 'Número de série...',
        registryNumber: 'Número de registro...',
        udtNumber: 'Número UDT...',
        manufacturedYear: 'Ano de fabricação...',
        manufacturerSymbol: 'Símbolo do fabricante...',
        priority: 'Prioridade...',
        quantity: 'Quantidade...',
        buyPrice: 'Preço de compra...',
        kind: 'Tipo...',
        toolsGroup: 'Grupo de ferramentas...',
        function: 'Função...',
        department: 'Departamento...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefone...',
        barCode: 'Código de barras',
        color: 'Cor...',
        icon: 'Ícone...',
        machine: 'Máquina...',
        tool: 'Ferramenta...',
        urgentAndOutdated: 'Urgente e obsoleto',
        urgent: 'Urgente',
        expired: 'Expirado',
        manufacturer: 'Fabricante',
    },
    errors: {
        error: 'Ocorreu um erro',
        wrongEmail: 'Email inválido',
        wrongPasswordLength:
            'A senha deve ter pelo menos 8 caracteres de comprimento.',
        wrongCodeLength:
            'O código deve ter pelo menos 5 caracteres de comprimento.',
        passwordsNotMatch: 'As senhas não correspondem',
        codesNotMatch: 'Os códigos não correspondem',
        codeAlreadyInUse: 'Código já utilizado',
        expiresDateLowerThanIssued:
            'A data de expiração não pode ser menor que a data de emissão.',
        cannotMoveToTheSameLocation: 'Não é possível mover para o mesmo local.',
        locationRequired: 'Localização é obrigatória.',
        putQuantity: 'Coloque a quantidade para separar.',
        valueGreaterThanQuantity: 'O valor é maior que a quantidade total.',
        wholeCannotBeDistinguished: 'O todo não pode ser distinguido.',
        yearMustBeGreaterThan: 'O ano deve ser maior que ',
        passwordConfirmationNotMatch: 'As senhas não correspondem',
        mustBeInteger: 'O valor deve ser um número inteiro',
        valueTooLong: 'Valor muito longo',
        wrongPhoneNumber: 'Número de telefone incorreto',
        phoneNumberAlreadyTaken: 'Número de telefone já utilizado',
        emailAlreadyTaken: 'Email já utilizado',
        notFound: 'Não encontrado',
        sessionExpired: 'Sessão expirada',
        tenantNotFound:
            'A configuração indicada não existe. Verifique o endereço do site e tente novamente.',
        selectEquipmentTypeToConfigureParameters:
            'Selecione o tipo de equipamento para configurar os parâmetros.',
        noParametersToConfigure:
            'O tipo de equipamento selecionado não tem parâmetros para configurar.',
        terminalAlreadyRegistered: 'Terminal já registrado.',
        invalidPin: 'PIN inválido',
        eventCollision:
            'O horário do evento que você deseja adicionar se sobrepõe ao horário de outro evento.',
        mustStartWithSlash: 'Deve começar com /',
        mustBeBetween: 'O valor deve estar entre:',
        minLength: 'Comprimento mínimo: ',
        maxLength: 'Comprimento máximo: ',
        invalidInputForCodeType:
            'Entrada inválida para o tipo de código selecionado',
        invalidCodeOrNoPermission:
            'O código é inválido ou você não tem permissões suficientes para realizar esta ação.',
        endDateLowerThanStart:
            'A data final não pode ser inferior à data inicial',
        iconAlreadyTaken: 'O ícone já foi escolhido',
        notEnoughQuantityInStorage: 'Quantidade insuficiente no estoque.',
        valueTooLow: 'Valor muito baixo',
        valueTooHigh: 'Valor muito alto',
        maxAvailableQuantity: 'Número máximo',
        someFilesRejectedDueToSize:
            'Alguns ficheiros foram rejeitados devido ao seu tamanho. Tamanho máximo de ficheiro único:',
        cameraDeviceNotFound: 'Dispositivo de câmara não encontrado',
        cameraPermissionDenied:
            'O acesso à câmara do dispositivo foi bloqueado nas definições do local, reiniciar as definições do local e permitir que a câmara seja utilizada.',
        passwordResetLinkExpired: 'O link de redefinição de senha expirou',
        noInternetConnection: 'Sem conexão com a internet',
        minimum: 'Mínimo',
        mustBeGreaterThan: 'Deve ser maior que',
        noEventTypesDefined: 'Nenhum tipo de evento definido',
        regexPatternDelimiterError:
            'O separador deve ser omitido com o carácter \\ npor exemplo: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'O email não corresponde ao padrão definido no inquilino',
        partMustHaveEntriesToCorrectQuantity:
            'A peça deve ter entradas para corrigir a quantidade.',
        fileTooBigToOpenWillBeDownloaded:
            'O arquivo é muito grande para abrir, o arquivo será baixado para o seu dispositivo.',
        entriesNotSavedDueToCollision:
            'As entradas não foram adicionadas. Os eventos já existem no horário selecionado.',
        someEntriesWereRejected:
            'Algumas entradas não foram adicionadas porque entram em conflito com outros eventos.',
        toolAlreadyInCart: 'Esta ferramenta já está no seu carrinho',
        toolAlreadyTaken: 'Esta ferramenta já foi lançada',
        toolIsNotTaken: 'Esta ferramenta não foi lançada',
        documentNotEditable: 'Este documento não pode ser editado',
        notPermissionsToEditDocument:
            'Você não tem permissão para editar este documento',
        cannotLoadDocumentNoPath:
            'O documento não pôde ser carregado – endereço inválido',
        locationNameNotMatchPatternDefiniedInTenant:
            'O nome não corresponde à regra definida nas configurações',
        noFloorLayoutProvided: 'O chão não tem mapa definido',
        maximum: 'Valor máximo',
        allLanguagesRequired: 'Preencha o valor em todos os idiomas',
        noItemsAvailable: 'Nenhum item disponível',
        noFlagsConfigured: 'Nenhuma sinalização definida',
        noSkillsDefined: 'Nenhuma habilidade definida',
        someoneIsWorkingOnIssue:
            'Nem todos os funcionários concluíram seu trabalho neste relatório. Tem certeza que deseja terminar?',
        fillAllRequiredParameters: 'Preencha todos os parâmetros necessários.',
        issueLimitError:
            'O limite de questões na categoria selecionada para foi atingido: ',
        issueLimitError2: 'e função: ',
        duplicateError: 'Este valor já existe',
        versionErrorMessage:
            'Suas alterações recentes não foram salvas porque outra pessoa fez alterações ao mesmo tempo. Atualize a página e tente novamente.',
        firstLoginTrustedDeviceError:
            'O primeiro login em um novo dispositivo requer a inserção de seu endereço de e-mail e senha.',
        tagNotFound: 'Cartão/tag não reconhecido',
        noChecklistsAssignedToControl:
            'O controle selecionado não possui uma lista de verificação atribuída a ele',
        lockerNotConnected: 'O cadeado não está conectado',
        lockerNotAvailable: 'O cadeado não está disponível',
        noChecklistItemsError: 'A lista de verificação não está configurada',
    },
    navDrawer: {
        dashboard: 'Painel de Controle',
        issues: 'Questões',
        timetable: 'Agenda',
        machines: 'Máquinas',
        tools: 'Ferramentas',
        parts: 'Peças',
        storage: 'Armazém',
        staff: 'Funcionários',
        configuration: 'Configuração',
        notes: 'Notas',
        notifications: 'Notificações',
        profile: 'Perfil',
        supervision: 'Supervisão',
    },
    barcodeScanner: {
        barCode: 'Código de barras',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Categoria...',
        selectCategory: 'Selecione a categoria',
        noSubcategories: 'Não há subcategorias',
    },
    companies: {
        addCompany: 'Adicionar empresa',
        editCompany: 'Editar empresa',
        fullName: 'Nome completo',
        shortName: 'Nome curto',
        group: 'Grupo',
        country: 'País',
        city: 'Cidade',
        street: 'Rua',
        postCode: 'CEP',
        phone: 'Telefone',
        email: 'Email',
        website: 'Website',
        NIP: 'NIP',
        REGON: 'Registro Nacional de Empresas',
        active: 'Ativo',
        nameRequired: 'Nome é obrigatório',
        shortNameRequired: 'Nome curto é obrigatório',
    },
    issues: {
        tookAt: 'Tirada às',
        changeHistory: 'Histórico de alterações',
        load: 'Carregar',
        date: 'Data',
        createdBy: 'Criado por',
        action: 'Ação',
        data: 'Dados',
        created: 'Criado',
        updated: 'Atualizado',
        deleted: 'Excluído',
        restored: 'Restaurado',
        issues: 'Questões',
        issue: 'Questão',
        by: 'por',
        name: 'Nome',
        applicantsDescription: 'Descrição do solicitante',
        accidentDescription: 'Descrição do acidente',
        jobDescription: 'Descrição do trabalho',
        jobSummary: 'Resumo do trabalho',
        category: 'Categoria',
        status: 'Status',
        noFlow: '[Sem fluxo]',
        equipment: 'Equipamento',
        criticality: 'Criticidade',
        hour: 'Hora',
        formalConfirmation: 'Confirmação formal',
        formalConfirmationShortcut: 'CF',
        formalConfirmationRequired: 'CF necessária',
        parameter: 'Parâmetro',
        value: 'Valor',
        addIssue: 'Adicionar questão',
        expectedCompletionDate: 'Data prevista de conclusão',
        issueDescription: 'Descrição da questão',
        partsUsage: 'Uso de peças',
        assignedEmployees: 'Funcionários atribuídos',
        requiredHelp: 'Ajuda necessária',
        returnParts: 'Retornar peças',
        confirmUnassignEmployeeWhoTakenIssue:
            'Este funcionário pegou a questão selecionada. Você deseja removê-lo?',
        responsibleUser: 'Usuário responsável',
        responsibleRules: 'Usuários responsáveis - regras',
    },
    machines: {
        machines: 'Máquinas',
        xIssuesNotPlanned: ' (não planejado)',
        noIssues: 'Sem questões',
    },
    maintenance: {
        maintenance: 'Manutenção',
    },
    notes: {
        notes: 'Notas',
        note: 'Nota',
        title: 'Título',
        archived: 'Arquivado',
    },
    parts: {
        parts: 'Peças',
        warehouseOutgoings: 'Saídas do armazém',
        fittingEquipmentTypes: 'Tipos de equipamentos adequados',
        goToEquipmentType: 'Ir para tipo de equipamento',
        selectPart: 'Selecionar peça',
        usageReason: 'Razão',
        usageOtherReason: 'Outro',
        replacements: 'Substituições',
        partEntry: 'Entrada de peças',
        goToPart: 'Ir para peça',
        fittingMachines: 'Máquinas de correspondência',
    },
    costCenter: {
        costCenter: 'Centro de custos',
    },
    equipmentTypes: {
        equipment: 'Equipamento',
        newEquipmentType: 'Novo tipo de equipamento',
        fittingParts: 'Peças adequadas',
        goToParts: 'Ir para peças',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Definições de máquinas e ferramentas',
    },
    flows: {
        flow: 'Fluxo',
        states: 'Estados',
        transitions: 'Transições',
        state: 'Estado',
        default: 'Padrão',
        warning: 'Aviso',
        problem: 'Problema',
        fixing: 'Correção',
        finished: 'Finalizado',
    },
    parameters: {
        categoryParameter: 'Parâmetro da categoria',
        equipmentTypeParameter: 'Parâmetro do tipo de equipamento',
    },
    staff: {
        staff: 'Funcionários',
        editUserAccess: 'Editar acesso de usuário',
        permissionsUpdated: 'Permissões atualizadas',
        passwordUpdated: 'Senha atualizada',
        codeUpdated: 'Código atualizado',
        changePasswordAndCode: 'Alterar senha e código',
        goToLicenses: 'Ir para licenças',
        editAccess: 'Editar acesso',
        editUser: 'Editar usuário',
        addUser: 'Adicionar novo usuário',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Status da conta',
        phoneNumber: 'Número de telefone',
        department: 'Departamento',
        passwordChange: 'Alteração de senha',
        codeChange: 'Alteração de código',
        newPassword: 'Nova senha',
        confirmNewPassword: 'Confirmar nova senha',
        changePassword: 'Alterar senha',
        newCode: 'Novo código',
        confirmNewCode: 'Confirmar novo código',
        changeCode: 'Alterar código',
        addEntry: 'Adicionar entrada',
        editEntry: 'Editar entrada',
        editLicense: 'Editar licença',
        addLicense: 'Adicionar licença',
        licenseNumber: 'Número da licença',
        prefferedLocale: 'Idioma preferido',
        oldPassword: 'Senha antiga',
        newPasswordConfirmation: 'Confirmar nova senha',
        reading: 'Exibindo',
        creating: 'Criando',
        updating: 'Atualizando',
        deleting: 'Excluindo',
        importScheduleFile: 'Importar um cronograma de um arquivo',
        importSchedule: {
            errors: {
                user_not_found: 'Usuário não encontrado [{user}]',
                user_found_many: '{count} usuários encontrados [{user}]',
                event_collision: 'Colisão de eventos',
                hour_cell_parse: 'Erro de análise de célula',
            },
        },
        oldCode: 'Código antigo',
        newCodeConfirmation: 'Confirmação do novo código',
        setAccessBasedOnProfile: 'Conceda acesso com base no perfil',
        selectAccessMergeType: 'Escolha como combinar permissões',
        noAccessesInProfileMessage:
            'O perfil selecionado não tem permissões. Você deseja substituir mesmo assim?',
    },
    breadCrumb: {
        configuration: 'Configuração',
        locations: 'Locais',
        home: 'Início',
        machines: 'Máquinas',
        tools: 'Ferramentas',
        issues: 'Questões',
        notes: 'Notas',
        maintenance: 'Manutenção',
        parts: 'Peças',
        warehouse: 'Armazém',
        dictionary: 'Dicionário',
        categories: 'Categorias',
        parameters: 'Parâmetros',
        costCenter: 'Centro de custo',
        flows: 'Fluxos',
        states: 'Estados',
        transitions: 'Transições',
        shiftSchemas: 'Esquemas de turnos',
        shifts: 'Turnos',
        definitionsOfMachinesAndToolsTypes:
            'Definições de tipos de máquinas e ferramentas',
        add: 'Adicionar',
        edit: 'Editar',
        staff: 'Equipe',
        licenses: 'Licenças',
        entries: 'Entradas',
        companiesDatabase: 'Banco de dados de empresas',
        companyManagement: 'Gerenciamento de empresas',
        companyData: 'Dados da empresa',
        supportedLanguages: 'Línguas suportadas',
        en: 'Inglês',
        pl: 'Polonês',
        es: 'Espanhol',
        de: 'Alemão',
        it: 'Italiano',
        fr: 'Francês',
        ru: 'Russo',
        uk: 'Ucraniano',
        pt: 'Português',
        defaultLanguage: 'Língua padrão',
        notifications: 'Notificações',
        notificationsManagement: 'Gerenciamento de notificações',
        myProfile: 'Meu perfil',
    },
    attributeTypes: {
        text: 'Texto',
        note: 'Nota',
        integer: 'Inteiro',
        decimal: 'Decimal',
        date: 'Data',
        time: 'Hora',
        dateTime: 'Data e hora',
        color: 'Cor',
        icon: 'Ícone',
        boolean: 'Sim/Não',
    },
    costCalculator: {
        costCalculator: 'Calculadora de custo',
        waitTime: 'Tempo de espera',
        serviceTime: 'Tempo de serviço',
        suspendTime: 'Tempo de suspensão',
        totalTime: 'Tempo total',
        estimatedCost: 'Custo estimado',
        calculate: 'Calcular',
        withoutParts: 'Sem peças',
        timeOfReportingIssue: 'Hora de relatório de problema',
        timeOfServiceStart: 'Hora de início do serviço',
        timeOfReportingEnd: 'Hora de término do serviço',
        days: 'Dias',
        hours: 'Horas',
        minutes: 'Minutos',
        enterNewTime: 'Inserir novo tempo',
        fromIssueReportToServiceStart:
            'Tempo do relatório de problema até o início do serviço',
        fromServiceStartToServiceEnd:
            'Tempo do início do serviço até o término do serviço',
        workTime: 'Tempo de trabalho',
        includeAwaitingTime: 'Incluir tempo de espera',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Meus problemas',
                assignedToMe: 'Atribuído a mim',
                assignedToGroup: 'Atribuído ao meu grupo',
                tookByMe: 'Pego por mim',
                takeIssueBtn: 'Pegar',
                arriveIssueBtn: 'Cheguei',
                finishIssueBtn: 'Finalizar',
                history: 'Histórico',
                myResponsible: 'Eu estou responsável por',
            },
        },
    },
    synchronization: {
        enabled: 'Habilitado',
        hasHeaders: 'Tem cabeçalhos',
        leaveFile: 'Deixar arquivo',
        host: 'Anfitrião',
        port: 'Porta',
        protocol: 'Protocolo',
        username: 'Nome de usuário',
        password: 'Senha',
        root: 'Raiz',
        encoding: 'Codificação',
        separator: 'Separador',
        externalSystemId: 'ID do sistema externo',
        cronExpression: 'Expressão Cron',
        appendFullStock: 'Anexar estoque completo',
        includeHeaders: 'Incluir cabeçalhos',
        withTrashed: 'Com dados excluídos',
        filePattern: 'Padrão de arquivo',
    },
    processes: {
        created_at: 'Criado em',
        started_at: 'Iniciado em',
        updated_at: 'Atualizado em',
        finished_at: 'Finalizado em',
        attempts: 'Tentativas',
        queue: 'Fila',
        job_id: 'ID do trabalho',
        job_uuid: 'UUID do trabalho',
        progress_max: 'Progresso máximo',
        progress_now: 'Progresso atual',
        outputMessage: 'Mensagem de saída',
        status: {
            queued: 'em fila',
            executing: 'executando',
            finished: 'finalizado',
            failed: 'falhou',
            retrying: 'tentando novamente',
            undefined: 'indefinido',
        },
    },
    weekDays: {
        mo: 'Segunda-feira',
        tu: 'Terça-feira',
        we: 'Quarta-feira',
        th: 'Quinta-feira',
        fr: 'Sexta-feira',
        sa: 'Sábado',
        su: 'Domingo',
    },
    reports: {
        reports: 'Relatórios',
        dateFrom: 'Data de início',
        dateTo: 'Data de término',
        types: {
            operation_sheet: 'Planilha operacional',
            issue_summary: 'Resumo da questão',
            grouped_summary: 'Relatório resumido',
            storage_operations: 'Operações de armazém',
            part_quantity_export: 'Quantidade de peças',
        },
        reportFor: 'Relatório para',
        includeQuantityLeft0: 'Incluir peças com quantidade nula',
    },
    logs: {
        issues: {
            escalation: 'Escalation ({minutes} min) - notificação enviada',
        },
        issueEmployee: {
            assignedAt: 'Funcionário atribuído:',
            receivedAt: 'Funcionário recebeu:',
            tookAt: 'Funcionário assumiu:',
            finishedAt: 'Funcionário concluiu:',
            deletedAt: 'Funcionário excluído da denúncia',
        },
    },
    units: {
        no: 'Pedaço',
        st: 'Definir',
    },
    rrule: {
        frequency: 'Frequência',
        dtstart: 'Data de início',
        tzid: 'Fuso horário',
        until: 'Até',
        count: 'Contar',
        interval: 'Intervalo',
        wkst: 'Dia de início',
        byweekday: 'No dia da semana',
        bymonth: 'Por mês',
        yearly: 'Anual',
        monthly: 'Por mês',
        weekly: 'Semanalmente',
        daily: 'Diário',
        hourly: 'De hora em hora',
        minutely: 'Minuciosamente',
        secondly: 'em segundo lugar',
        infinitePeriodicityMessage:
            'A periodicidade é infinita, devido ao desempenho, apenas 500 linhas são exibidas',
    },
    months: {
        jan: 'Janeiro',
        feb: 'Fevereiro',
        mar: 'Marchar',
        apr: 'Abril',
        may: 'Poderia',
        jun: 'Junho',
        jul: 'Julho',
        aug: 'Agosto',
        sep: 'Setembro',
        oct: 'Outubro',
        nov: 'Novembro',
        dec: 'Dezembro',
    },
    charts: {
        charts: 'Gráficos',
        count: 'Número de problemas',
        total: 'Tempo total de problemas (do relatório ao fim)',
        serw: 'Tempo total de reparo (Ttotal - Twait)',
        mttr1: 'Tempo médio do relatório ao fim',
        mttr2: 'Tempo médio da tomada ao fim',
        mtbf: 'Tempo médio de atividade entre problemas',
        mttf: 'Tempo médio para falha',
    },
    accessMergeValues: {
        sum: 'Soma',
        product: 'Produtos',
        overwrite: 'Substituir',
    },
    tpm: {
        history: 'História',
        standardObstacle: 'Obstáculo padrão',
        customObstacle: 'Obstáculo personalizado',
        bhp: 'Segurança e Saúde no Trabalho',
        returnToMainPage: 'Voltar para a página principal',
        bhpMessage:
            'Se você identificar qualquer risco à segurança, por favor, informe imediatamente ao seu supervisor direto e utilize o formulário de relato localizado abaixo do mural de avisos.',
        ok: 'Ok',
        send: 'Enviar',
        description: 'Descrição',
        title: 'Título',
        realization: 'Realização',
        answer: 'Resposta',
        pendingSurveys: 'Pesquisas pendentes',
        surveys: 'Pesquisas',
        systemSurvey: 'Pesquisa de sistema',
        addPage: 'Adicionar página',
        createSurvey: 'Criar pesquisa',
        addSection: 'Adicionar seção',
        addQuestion: 'Adicionar pergunta',
        questionContent: 'Conteúdo da pergunta',
        answerOption: 'Opção de resposta',
        addQuestionAnswer: 'Adicionar opção de resposta',
        surveyName: 'Nome da pesquisa',
        sectionName: 'Nome da seção',
        noSurveyAnswers: 'Sem respostas',
        removeSection: 'Remover seção',
        published: 'Publicado',
        unpublished: 'Não publicado',
        pendingPublication: 'Alterações pendentes de publicação',
        removeQuestion: 'Remover pergunta',
        removeAnswer: 'Remover opção de resposta',
        publish: 'Publicar',
        unpublish: 'Despublicar',
        previewResults: 'Visualizar resultados',
        supervisior: 'Supervisor',
        surveyResults: 'Resultados da pesquisa',
        surveysEvents: 'Configuração de eventos - pesquisas',
        operatedBy: 'Operado por',
        confirmReadInformations: 'Confirmo que li as informações',
        noticeContent: 'Conteúdo do aviso',
        notice: 'Aviso',
        surveyEventName: 'Nome do evento',
        survey: 'Pesquisa',
        newIssue: 'Nova ocorrência',
        surveyEventConfigurationAlreadyExists:
            'Essa configuração de evento já existe',
        lastComment: 'Último comentário da pessoa responsável',
        surveyNotConfigured: 'Pesquisa não configurada',
        fillSurvey: 'Preencher pesquisa',
        singleSurveyEntries: 'resultados únicos',
        groupedSurveyEntries: 'Resultados agrupados',
        publicationId: 'ID da publicação',
        publicationDate: 'Data da publicação',
        versionId: 'ID da versão',
        answersCount: 'Número de respostas',
        answers: 'Respostas',
        withoutSupervisor: 'Sem supervisor',
        defaultSupervisor: 'Supervisor padrão',
        flowStateFlags: 'sinalizadores de status',
        qrActionsSettings: 'Configurações de ação do código QR',
        loginRequired: 'Requer login',
        questionContext: 'O contexto da pergunta',
        currentSurveyVersionPreview: 'Visualização da versão atual da pesquisa',
        surveyDescription: 'Descrição da pesquisa',
        sectionDescription: 'Descrição da seção',
        instructions: 'Instruções',
        instruction: 'Instrução',
        instructionRevisions: 'Revisões',
        instructionRevision: 'Revisão',
        checklists: 'Lista de verificação',
        checklist: 'Lista de controlo',
        checklistItem: 'Item da lista',
        manageChecklistFields: 'Gerir itens da lista',
        checklistItemDisplayOptions: 'Itens exibidos',
        revisionAutoRejectedInfo: '[Sistema] Rejeitado - criada nova revisão',
    },
    checklists: {
        itemBasic: 'Elemento básico',
        itemSeparator: 'Separador',
        itemSection: 'Seção',
        publish: 'Publicar',
        previewCurrentVersion: 'Pré-visualização da versão atual',
    },
};
